export const TAGS_MARGIN = 12;